/**
 * Takes an input and formats it for display in a table.
 * @param {string} input
 */
export const formatTableString = (input?: Maybe<string>): string => {
    if (
        input === null ||
        input === undefined ||
        input?.length === 0 ||
        input === 'not_reported'
    ) {
        return '—';
    }

    return input;
};
